import { Users } from 'lucide-react'
import './SharedBadge.css'

interface SharedBadgeProps {
  // 'full' shows the "Shared" text pill (project cards, detail header); 'icon' shows just the icon
  // for tight spots like the sidebar rail. Both carry the same accessible label and tooltip.
  variant?: 'full' | 'icon'
  className?: string
}

// Visual cue that a project was shared with the current user (they're a member, not the owner). Used
// wherever a project surfaces — the sidebar nav, the project gallery cards, and the detail header —
// so a shared project reads the same everywhere. Gate rendering on isSharedProject at the call site.
export default function SharedBadge({ variant = 'full', className }: SharedBadgeProps) {
  const label = 'Shared with you'
  return (
    <span
      className={`shared-badge shared-badge--${variant}${className ? ` ${className}` : ''}`}
      title={label}
      aria-label={label}
      data-testid="shared-badge"
    >
      <Users size={variant === 'icon' ? 13 : 12} aria-hidden="true" />
      {variant === 'full' && <span className="shared-badge__text">Shared</span>}
    </span>
  )
}
